import BaseDangerDetail from '../../../common/baseDangerDetail/BaseDangerDetail';

export default class ResearchPerson extends BaseDangerDetail {
    constructor(props) {
        super(props);
        this.title = '研发人员情况';
    }

    getColumns = () => {
        return [{
            title: '',
            dataIndex: 'year'
        }, {
            title: '研发人员数量',
            dataIndex: 'totalNum'
        }, {
            title: '研发人员人数占比',
            dataIndex: 'percent'
        }, {
            title: '行业研发人员占比均值',
            dataIndex: 'avgPercent'
        }];
    };
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialFraudAnalysis/subComponents/details/ResearchPerson.jsx